/**
 * Do not edit directly
 * Generated on Tue, 05 Aug 2025 14:28:15 GMT
 */

export const PaddingSpacingNone = 0;
export const PaddingSpacing3Xs = 4;
export const PaddingSpacing2Xs = 12;
export const PaddingSpacingXs = 16;
export const PaddingSpacingS = 24;
export const PaddingSpacingSm = 32;
export const PaddingSpacingM = 40;
export const PaddingSpacingMl = 48;
export const PaddingSpacingL = 56;
export const PaddingSpacingXl = 64;
export const PaddingSpacing2Xl = 80;
export const PaddingSpacing3Xl = 96;
export const PaddingSpacing4Xl = 160;
export const SizingXs = 2;
export const SizingS = 4;
export const SizingM = 8;
export const SizingL = 12;
export const SizingXl = 16;
export const SizingXxl = 32;
export const SizingXxxl = 48;
export const RadiusXs = 4;
export const RadiusS = 8;
export const RadiusM = 12;
export const RadiusL = 16;
export const RadiusXl = 16;
export const RadiusXxl = 32;
export const RadiusXxxl = 48;
export const FontFamiliesPrimary = "Instrument Sans";
export const FontFamiliesSecondary = "Space Grotesk";
export const LineHeights100 = 16;
export const LineHeights200 = 18;
export const LineHeights300 = 20;
export const LineHeights400 = 24;
export const LineHeights500 = 28;
export const LineHeights600 = 32;
export const LineHeights700 = 36;
export const LineHeights800 = 40;
export const LineHeights900 = 48;
export const LineHeights1000 = 64;
export const LineHeights1100 = 84;
export const FontWeights400 = "Regular";
export const FontWeights500 = "Medium";
export const FontWeights700 = "Bold";
export const FontWeightsItalic = "Italic";
export const FontSize100 = 13;
export const FontSize200 = 16;
export const FontSize300 = 18;
export const FontSize400 = 20;
export const FontSize500 = 24;
export const FontSize600 = 30;
export const FontSize700 = 36;
export const FontSize800 = 48;
export const FontSize900 = 64;
export const LetterSpacing0 = "0%";
export const LetterSpacing1 = "3%";
export const LetterSpacing2 = "10%";
export const ParagraphSpacing0 = 0;
export const ParagraphSpacing1 = 10;
export const TabletH1FontFamily = "Instrument Sans";
export const TabletH1FontWeight = "Bold";
export const TabletH1LineHeight = 48;
export const TabletH1FontSize = 36;
export const TabletH1TextDecoration = "none";
export const TabletH2FontFamily = "Instrument Sans";
export const TabletH2FontWeight = "Bold";
export const TabletH2LineHeight = 48;
export const TabletH2FontSize = 30;
export const TabletH2TextDecoration = "none";
export const TabletH3FontFamily = "Instrument Sans";
export const TabletH3FontWeight = "Bold";
export const TabletH3LineHeight = 36;
export const TabletH3FontSize = 24;
export const TabletH3TextDecoration = "none";
export const TabletH4FontFamily = "Instrument Sans";
export const TabletH4FontWeight = "Bold";
export const TabletH4LineHeight = 32;
export const TabletH4FontSize = 20;
export const TabletH4TextDecoration = "none";
export const TabletH5FontFamily = "Instrument Sans";
export const TabletH5FontWeight = "Bold";
export const TabletH5LineHeight = 28;
export const TabletH5FontSize = 18;
export const TabletH5TextDecoration = "none";
export const TabletH6FontFamily = "Space Grotesk";
export const TabletH6FontWeight = "Medium";
export const TabletH6LineHeight = 32;
export const TabletH6FontSize = 20;
export const TabletH6TextDecoration = "none";
export const TabletSubtitleFontFamily = "Space Grotesk";
export const TabletSubtitleFontWeight = "Regular";
export const TabletSubtitleLineHeight = 28;
export const TabletSubtitleFontSize = 18;
export const TabletSubtitleTextDecoration = "none";
export const TabletButtonFontFamily = "Space Grotesk";
export const TabletButtonFontWeight = "Bold";
export const TabletButtonLineHeight = 16;
export const TabletButtonFontSize = 16;
export const TabletButtonTextDecoration = "none";
export const TabletButtonLetterSpacing = "3%";
export const TabletButtonSmallFontFamily = "Space Grotesk";
export const TabletButtonSmallFontWeight = "Regular";
export const TabletButtonSmallLineHeight = 16;
export const TabletButtonSmallFontSize = 13;
export const TabletButtonSmallTextDecoration = "none";
export const TabletButtonSmallLetterSpacing = "3%";
export const TabletBodyFontFamily = "Instrument Sans";
export const TabletBodyFontWeight = "Regular";
export const TabletBodyLineHeight = 24;
export const TabletBodyFontSize = 16;
export const TabletBodyTextDecoration = "none";
export const TabletBodyParagraphSpacing = 10;
export const TabletBodyStrongFontFamily = "Instrument Sans";
export const TabletBodyStrongFontWeight = "Bold";
export const TabletBodyStrongLineHeight = 24;
export const TabletBodyStrongFontSize = 16;
export const TabletBodyStrongTextDecoration = "none";
export const TabletBodyStrongParagraphSpacing = 10;
export const TabletBodyItalicFontFamily = "Instrument Sans";
export const TabletBodyItalicFontWeight = "Italic";
export const TabletBodyItalicLineHeight = 24;
export const TabletBodyItalicFontSize = 16;
export const TabletBodyItalicTextDecoration = "none";
export const TabletBodyItalicParagraphSpacing = 10;
export const TabletBodyLinkFontFamily = "Instrument Sans";
export const TabletBodyLinkFontWeight = "Regular";
export const TabletBodyLinkLineHeight = 24;
export const TabletBodyLinkFontSize = 16;
export const TabletBodyLinkTextDecoration = "underline";
export const TabletBodyLinkParagraphSpacing = 10;
export const TabletBodySmallFontFamily = "Instrument Sans";
export const TabletBodySmallFontWeight = "Regular";
export const TabletBodySmallLineHeight = 20;
export const TabletBodySmallFontSize = 13;
export const TabletBodySmallTextDecoration = "none";
export const TabletBodySmallStrongFontFamily = "Instrument Sans";
export const TabletBodySmallStrongFontWeight = "Bold";
export const TabletBodySmallStrongLineHeight = 20;
export const TabletBodySmallStrongFontSize = 13;
export const TabletBodySmallStrongTextDecoration = "none";
export const TabletBodySmallItalicFontFamily = "Instrument Sans";
export const TabletBodySmallItalicFontWeight = "Italic";
export const TabletBodySmallItalicLineHeight = 20;
export const TabletBodySmallItalicFontSize = 13;
export const TabletBodySmallItalicTextDecoration = "none";
export const TabletBodySmallLinkFontFamily = "Instrument Sans";
export const TabletBodySmallLinkFontWeight = "Regular";
export const TabletBodySmallLinkLineHeight = 20;
export const TabletBodySmallLinkFontSize = 13;
export const TabletBodySmallLinkTextDecoration = "underline";
export const TabletCategoryFontFamily = "Space Grotesk";
export const TabletCategoryFontWeight = "Bold";
export const TabletCategoryLineHeight = 20;
export const TabletCategoryFontSize = 13;
export const TabletCategoryTextDecoration = "none";
export const TabletCategoryLetterSpacing = "10%";
export const TabletTagFontFamily = "Space Grotesk";
export const TabletTagFontWeight = "Medium";
export const TabletTagLineHeight = 20;
export const TabletTagFontSize = 13;
export const TabletTagTextDecoration = "none";
export const TabletCaptionFontFamily = "Space Grotesk";
export const TabletCaptionFontWeight = "Regular";
export const TabletCaptionLineHeight = 20;
export const TabletCaptionFontSize = 13;
export const TabletCaptionTextDecoration = "none";
export const TabletLabelFontFamily = "Instrument Sans";
export const TabletLabelFontWeight = "Medium";
export const TabletLabelLineHeight = 18;
export const TabletLabelFontSize = 13;
export const TabletLabelTextDecoration = "none";
export const TabletPlaceholderFontFamily = "Space Grotesk";
export const TabletPlaceholderFontWeight = "Medium";
export const TabletPlaceholderLineHeight = 16;
export const TabletPlaceholderFontSize = 13;
export const TabletPlaceholderTextDecoration = "none";
export const TextDecorationNone = "none";
export const TextDecorationUnderline = "underline";
export const ComponentButtonPaddingLeft = 24;
export const ComponentButtonPaddingRight = 24;
export const ComponentButtonPaddingTop = 16;
export const ComponentButtonPaddingBottom = 16;
export const Numbers0 = 0;
export const Numbers2 = 2;
export const Numbers4 = 4;
export const Numbers8 = 8;
export const Numbers12 = 12;
export const Numbers14 = 14;
export const Numbers16 = 16;
export const Numbers20 = 20;
export const Numbers22 = 22;
export const Numbers24 = 24;
export const Numbers32 = 32;
export const Numbers40 = 40;
export const Numbers48 = 48;
export const Numbers56 = 56;
export const Numbers64 = 64;
export const Numbers80 = 80;
export const Numbers96 = 96;
export const Numbers128 = 128;
export const Numbers160 = 160;
export const Numbers248 = 240;
